import {notificationOpen} from "../actions/notificationActions";
import {clearToken, getToken} from "../actions/loginActions";
import {QD_API_AUTH_URL} from "../constants/systemConstants";
import {logout} from "../actions/loginActions";
import {debugLog, debugWarn} from "./debugLogger";
//import {closeDrawer} from "../actions/drawerActions";

export const errorResponse = function(error, dispatch) {
    let message = error.message;

    if (error.response && error.response.data) {
        let data = error.response.data;
        message = (data.description || data.message) ? data.description || data.message : message;
    }

    debugLog('HTTP_ERR',`Error pipeline status=${error?.response?.status} url=${error?.config?.url}`, {message});

    // Simple 401 loop guard: track recent consecutive 401 clears
    const NOW = Date.now();
    if (!window.__auth401Log) window.__auth401Log = [];
    // prune older than 30s
    window.__auth401Log = window.__auth401Log.filter(t => NOW - t < 30000);

    let isLoggedIn = getToken();
    const is401 = (error.response && error.response.status === 401) || !isLoggedIn;
    if (is401) {
        window.__auth401Log.push(NOW);
        const recent = window.__auth401Log.length;
        const SUPPRESS_THRESHOLD = 5; // more than 5 in 30s -> suppress further clears
        if (recent > SUPPRESS_THRESHOLD) {
            debugWarn('AUTH',`Suppressing clearToken (401 loop guard tripped, recent=${recent})`);
            // Surface a notification once
            if (!window.__auth401Suppressed) {
                window.__auth401Suppressed = true;
                dispatch(notificationOpen("Authentication instability detected. Please refresh or re-login manually.", error));
            }
            throw error; // stop escalation
        }

        let loginMessage = (error.config.url === QD_API_AUTH_URL)?
            "The username and password combination did not match. Please try again." :
            "Session expired. Please sign in." ;
        debugWarn('AUTH','Dispatching clearToken due to 401 or missing token');
        dispatch(clearToken(loginMessage));
    }
    else if (error.response && error.response.status === 403) {
        // THis happens when a user on the server switches between admin and portal
        debugWarn('AUTH','Dispatching logout due to 403');
        dispatch(logout());
    }
    else {
        debugLog('HTTP_ERR','Dispatching notification for non-auth error');
        dispatch(notificationOpen(message, error));
    }

    throw error;
};
